<!-- 打印调拨单 -->
<template>
    <div>
        <div id="printContent" class="print-zone">
            <div class="print-for" v-bind:key="item.TOId" v-for="item in printList">
                <div class="print-title-view">
                    <!-- <div class="order-code">
            <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
            <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
          </div> -->
                    <div class="print-title">调拨单</div>
                    <div class="order-detail">单号：{{ item.TOCode }}</div>
                    <div class="order-detail">
                        日期：<span>{{ orderdata.CreateTime }}</span>
                    </div>
                </div>
                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 10%">调出仓库</div>
                        <div class="div-table-cell fdzt" style="width: 40%">
                            {{ item.OutWarehouseName }}
                        </div>
                        <div class="div-table-cell" style="width: 10%">调入仓库</div>
                        <div class="div-table-cell fdzt" style="width: 40%">
                            {{ item.InWarehouseName }}
                        </div>
                    </div>
                    <el-table :data="tableData" border class="fkyou" header-row-class-name="fkyou" style="width: 100%">
                        <el-table-column label="序号" width="50px" sortable type="index"> </el-table-column>
                        <el-table-column prop="APCode" show-overflow-tooltip label="汽配编码"></el-table-column>
                        <el-table-column prop="GoodName" show-overflow-tooltip label="配件名称"> </el-table-column>
                        <el-table-column prop="AutoSerise" show-overflow-tooltip label="车型"> </el-table-column>
                        <el-table-column width="70px" label="出库数">
                            <template slot-scope="scope">
                                {{ scope.row.Count + ' ' + scope.row.Unit }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="GoodsLocation" width="120px" label="调出参考仓位"> </el-table-column>
                    </el-table>
                </div>
                <el-row type="flex" class="order-remark">
                    <el-col :span="24">备注：{{ item.Remark }}</el-col>
                </el-row>
            </div>
        </div>
        <div class="re-submit">
            <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'">打印</el-button>
            <el-button @click="cancel()">关闭</el-button>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: {
        printIds: {
            type: Array
        },
        printType: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: this.$util.getLocalStorage('userMsg').EntpName,
            imgUrl: '',
            orderdata: [],
            tableData: []
        };
    },
    watch: {
        printList(value) {
            this.$nextTick(function () {
                try {
                    let canvas = this.$refs.canva[0];
                    QRCode.toCanvas(
                        canvas,
                        value[0].TOCode,
                        {
                            width: 80,
                            height: 80,
                            margin: 0,
                            scrollX: 0,
                            scrollY: 0
                        },
                        function (error) {}
                    );

                    setTimeout(() => {
                        html2canvas(canvas, {
                            width: 80,
                            height: 80,
                            scrollX: 0,
                            scrollY: 0
                        }).then(canvasRes => {
                            var imgData = canvasRes.toDataURL('image/png');
                            this.imgUrl = imgData;
                            canvas.style.display = 'none';
                        });
                    }, 1000);
                } catch (e) {
                    //
                }
            });
        }
    },
    mounted() {
        this.getTransOrder();
    },
    methods: {
        printedRecord() {
            this.$util
                .printedRecord({
                        OrderId: this.printIds[0],
                        Type: 6
                    },true);
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        // 获取表格数据
        getTransOrder() {
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetPrintTransferOrderData',
                    data: {
                        TOId: this.printIds[0]
                    }
                })
                .then(res => {
                    let _allNum = 0;
                    let data = res.data;
                    this.orderdata = res.data;
                    this.tableData = res.data.DetailList;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                    }
                    this.allNum = _allNum;
                    this.printList.push(res.data);
                });
        }
    }
};
</script>
<style lang="less">
.el-table th {
    padding-right: 0px;
}
.el-table .cell {
    padding-right: 0px;
}
.fkyou {
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
    margin-bottom: 0px;
}
.fkyou td {
    padding: 0;
    border-right: 1px solid #000;
    border-top: 1px solid #000;
}
.fkyou th {
    padding: 0;
    border: 1px solid #000;
}

.fkyou div {
    color: #000;
}
</style>
<style lang="less" scoped media="print">
.el-row {
    margin-bottom: 0;
}
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 64px 0 12px;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding-top: 5px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}

.print-table-main {
    width: 792px;
    margin-left: 1px;
    font-size: 12px;
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 11px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        // border-bottom: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
        margin: 0;
    }
    .pall-count {
        text-align: right;
    }
}
.btn-ctn-left {
    display: flex;
}
.fullCut {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fdzt {
    font-size: 14px;
}
</style>
